import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import Header from "../components/Header";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ExperienceDetail() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [e, setE] = useState(null);
  useEffect(() => { api.get(`/experiences/${slug}`).then((r) => setE(r.data)); }, [slug]);
  if (!e) return <div className="min-h-screen bg-ivory" />;

  const save = async () => {
    if (!user) { toast("Sign in to save experiences."); return; }
    try { await api.post("/saved", { slug }); toast.success("Saved to your profile."); }
    catch { toast.error("Could not save."); }
  };

  return (
    <div className="min-h-screen bg-ivory">
      <Header variant="light" active="experiences" />
      <section className="relative h-[80vh] w-full overflow-hidden">
        <img src={e.image} alt={e.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/30" />
        <div className="relative h-full flex flex-col justify-end px-6 lg:px-10 max-w-7xl mx-auto pb-14 text-ivory">
          <p className="eyebrow mb-4">{e.eyebrow} · {e.location}</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.03] max-w-3xl">{e.name}</h1>
        </div>
      </section>

      <section className="px-6 lg:px-10 max-w-7xl mx-auto py-14 grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 space-y-12">
          <p className="font-headline italic text-2xl text-ink/80 leading-snug">{e.blurb}</p>
          {e.story.map((s) => (
            <div key={s.h} className="border-t border-gold/30 pt-6">
              <p className="eyebrow mb-3">{s.h}</p>
              <p className="text-ink/75 leading-relaxed max-w-2xl">{s.p}</p>
            </div>
          ))}
        </div>
        <aside className="lg:col-span-1">
          <div className="border border-gold/30 p-8 sticky top-24">
            <p className="eyebrow mb-2">{e.pathway} Pathway</p>
            <p className="font-headline text-2xl leading-tight mb-6">{e.format}</p>
            <div className="space-y-3 text-sm text-ink/70 mb-8">
              <div className="flex justify-between border-b border-ink/10 pb-2"><span>Format</span><span className="text-ink text-right">{e.format}</span></div>
              {e.duration && <div className="flex justify-between border-b border-ink/10 pb-2"><span>Duration</span><span className="text-ink">{e.duration}</span></div>}
              {e.price_from && <div className="flex justify-between border-b border-ink/10 pb-2"><span>From</span><span className="text-ink">${e.price_from.toLocaleString()}</span></div>}
              {e.partner && <div className="flex justify-between border-b border-ink/10 pb-2"><span>Partner</span><span className="text-ink">{e.partner}</span></div>}
            </div>
            <a href="mailto:explore@luxewellexperiences.com" data-testid="inquire-btn" className="btn-lux w-full text-center block bg-ink text-ivory hover:bg-gold hover:text-ink mb-3">Request an invitation</a>
            <button data-testid="save-btn" onClick={save} className="btn-lux w-full text-center bg-transparent text-ink hover:bg-gold/10">Save to Profile</button>
          </div>
        </aside>
      </section>
    </div>
  );
}
